<template>
  <div>
    <full-page ref="fullpage" :options="options" id="fullpage">
    <div class="section">
      <page1 v-show="adv" :data="adv" />
    </div>
    <div class="section">
      <page2 v-show="about" :data="about" />
    </div>
    <div class="section">
      <page3 />
    </div>
    <div class="section">
      <page4 />
    </div>
    <div class="section">
      <page5 v-show="protocol" :data="protocol" />
    </div>
    <div class="section">
      <page6 />
    </div>
    <div class="section">
      <page7 v-show="contact" :data="contact" />
    </div>
  </full-page>
  </div>
</template>

<script>
import page1 from '@/components/page1'
import page2 from '@/components/page2'
import page3 from '@/components/page3'
import page4 from '@/components/page4'
import page5 from '@/components/page5'
import page6 from '@/components/page6'
import page7 from '@/components/page7'

export default {
  components: {
    page1,
    page2,
    page3,
    page4,
    page5,
    page6,
    page7
  },
  data () {
    return {
      options: {
        licenseKey: null,
        menu: '#menu',
        scrollingSpeed: 800,
        animateAnchor: false,
        anchors: ['home', 'about', 'champion', 'sale', 'protocol', 'consult', 'contact'],
        normalScrollElements: '.ban'
      },
      adv: null,
      about: null,
      protocol: null,
      contact: null
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$api('GET', '/index').then(res => {
        console.log(res)
        this.adv = res.data.adv
        this.about = res.data.agreement.about
        this.protocol = res.data.agreement.protocol
        this.contact = {
          phone: res.data.config.phone,
          email: res.data.config.email,
          people: res.data.config.people
        }
      })
    }
  }
}
</script>

<style>

</style>